import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { OrderRexAriaInfo } from '@features/orders/models/order-rex-aria.model';
import { HorusLoaderComponent } from '@shared/components/domain/horus-loader/horus-loader.component';

@Component({
  selector: 'app-order-integration-services',
  standalone: true,
  imports: [HorusLoaderComponent, MatIconModule],
  templateUrl: './order-integration-services.component.html',
  styleUrl: './order-integration-services.component.scss',
})
export class OrderIntegrationServicesComponent implements OnInit {
  ngOnInit(): void {
  }
  @Input()
  serviceInfo?: OrderRexAriaInfo;
  @Input()
  loaded?: boolean = false;
  @Output()
  redirectSection = new EventEmitter<string>();
}
